import { DataFlowOutput } from './DataFlowOutput';

export class DataFlowActionEvent {
  public Action: string;

  public Output: DataFlowOutput;
}
